export default __webpack_public_path__ + "static/media/tiktok.8a9452a0.png";